import React, { memo } from 'react';
import { Building2, GraduationCap, Calendar, Users, User } from 'lucide-react';
import { Button } from './ui/Button';
export function WhoWeServe() {
  const audiences = [{
    icon: <Building2 className="w-8 h-8" data-id="element-275" />,
    title: 'Businesses & Brands',
    description: 'Corporate apparel, uniforms, promotional products, and branded merchandise.',
    accentColor: 'pink' as const
  }, {
    icon: <GraduationCap className="w-8 h-8" data-id="element-276" />,
    title: 'Schools & Teams',
    description: 'Team uniforms, spirit wear, athletic apparel, and school merchandise.',
    accentColor: 'yellow' as const
  }, {
    icon: <Calendar className="w-8 h-8" data-id="element-277" />,
    title: 'Events & Fundraisers',
    description: 'Custom event shirts, fundraising merchandise, and commemorative apparel.',
    accentColor: 'teal' as const
  }, {
    icon: <Users className="w-8 h-8" data-id="element-278" />,
    title: 'Camps & Organizations',
    description: 'Camp designs, organization apparel, and group orders of all sizes.',
    accentColor: 'pink' as const
  }, {
    icon: <User className="w-8 h-8" data-id="element-279" />,
    title: 'Individuals & Small Orders',
    description: 'Personalized gifts, custom designs, and small batch orders welcome.',
    accentColor: 'yellow' as const
  }];
  const accentColors = {
    pink: 'text-wh-pink bg-pink-50',
    yellow: 'text-wh-yellow bg-yellow-50',
    teal: 'text-wh-teal bg-teal-50'
  };
  return <section className="py-24 bg-white" data-id="element-280">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-281">
        <div className="text-center mb-16" data-id="element-282">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-283">
            Who We Serve
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-284">
            From large corporate orders to individual custom projects, we
            deliver quality results for every customer.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-id="element-285">
          {audiences.map((audience, index) => <div key={index} className="bg-white p-8 rounded-xl border border-gray-100 hover:border-gray-200 hover:shadow-lg transition-all duration-300" data-id="element-286">
              <div className={`w-16 h-16 rounded-lg ${accentColors[audience.accentColor]} flex items-center justify-center mb-6`} data-id="element-287">
                {audience.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-288">
                {audience.title}
              </h3>
              <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-289">
                {audience.description}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-290">
          <Button variant="primary" size="lg" data-id="element-291">
            Start Your Custom Project
          </Button>
        </div>
      </div>
    </section>;
}